export const contest = {
  qjy: '去交易',
  grbm: '个人报名',
  qdl: '去登录',
  bsyjs: '比赛已结束',
  bsjs: '比赛结束',
  djs: '距离模拟交易大赛{v1}（倒计时）',
  days: '天',
  hours: '时',
  minutes: '分',
  seconds: '秒',
  ljyq: '立即邀请',
  tdbm: '团队报名',
  qzc: '去注册',
  qrsfgrbm: '确认是否参加个人报名？',
  qxbm: '取消报名',
  qrbm: '确认报名',
  gxnbmcg: '恭喜您，报名成功，您将获取10W USDT模拟金',
  xzjs: '选择您想成为的角色',
  cwty: '成为团员',
  cwtz: '成为团长',
  cjtd: '创建团队',
  jtgz: '建团规则：',
  jtgz1: '1.组团后24小时不足5人将自动解散，并自动报名模拟个人赛',
  jtgz2: '2.等待成团期间不能报名参与模拟个人赛',
  jtgz3: '3.成团建团后，您将无法加入其他团队和模拟个人赛',
  tdmc: '团队名称：',
  tdjj: '团队简介：',
  ljjt: '立即建团',
  tdmcbt: '请输入团队名称',
  tdjzbt: '请输入团队简介',
  cjzdcg: '创建战队成功！',
  xzjrtd: '选择自己想要加入的团队吧',
  sstdmc: '搜索团队名称',
  dqzdsl: '当前团队数量：{v1}，选择自己想要加入的团队',
  ddtdrs: '当前团队人数：{v1}人',
  tdrs: '团队人数：',
  tzmc: '团长名称：',
  jrtd: '加入团队',
  jrzdcg: '加入战队成功！',
  grfxlj: '个人分享链接：',
  grtjm: '个人推荐码：',
  tdfxlj: '团队分享链接：',
  tdtjm: '团队推荐码：',
  tdtzm: '团队队长名：',
  bctp: '保存图片',
  total: '共 {v1} 条',
  dd: '到第',
  qd: '确定',
  cyyj: '参与即有奖',
  jcdnn: 'USDT奖池等你拿！',
  jzcj: '盈利捐赠，参与抽奖',
  dqjc: '当前奖金池：',
  qjz: '去捐赠',
  jzsm: '捐赠说明',
  kjz: '您目前可捐赠 {v1} USDT公益基金，确认是否捐赠？',
  qxjz: '取消捐赠',
  qrjz: '确认捐赠',
  jzcg: '恭喜您，捐赠成功!',
  mnpjyds: '模拟交易大赛',
  bm: '报名：',
  bs: '比赛：',
  hyspjyds: '合约交易赛 ',
  xhspjyds: '现货交易赛',
  bmz: '报名中',
  jqqd: '敬请期待',
  bsz: '比赛中',
  yjs: '已结束',
  myptts: '模拟团队赛 ',
  mypzmxs: '周明星赛',
  mypgrs: '模拟个人赛',
  hyjyds: '合约交易赛 ',
  xhjyds: '现货交易赛',
  my: '我的',
  pm: '排名',
  dync: '队员昵称',
  dm: '队名',
  zdrs: '战队人数',
  nc: '昵称',
  ljzjy: '累计总交易',
  ljzjye: '总交易额',
  ljzyll: '累计总盈利率',
  zyll: '总盈利率',
  zdjl: '战队奖励',
  mypbsjl: '参赛有奖',
  myphycs: '参与模拟合约赛',
  myhyj: '报名成功即获100000U模拟合约金',
  ljbm: '立即参赛',
  tzjl: '开团有奖',
  ztcg: '5人成团，200人封顶',
  bwzbhl: '队长组团成功可获100000U+',
  yqjl: '邀请有奖',
  yqhycybs: '队长邀请，最高获100000U',
  hzhyj: '队员邀请，最高获50000U',
  mnttbssm: '模拟大赛团队赛比赛规则说明',
  // 团队赛规则
  csxq: '参赛详情：',
  csxq1: '1、活动报名起始日——比赛结束日期间用户（需实名认证后）均可随意开团，合约团队赛需满足团队人数 ≥ 5人；≤200人；开团后24H内未满5人，则战队将被自动解散，团队成员自动加入个人赛区。',
  csxq2: '2、用户仅可选择一个战队并加入，不可重复参赛、不可同时参与团队赛与个人赛，用户参团成功不可主动退出战队',
  ssgz: '赛事规则：',
  ssgz1: '1、队长福利：1）队长每邀请一位队员加入可获1000USDT模拟金，邀请奖励100000USDT封顶；',
  ssgz1_2: '          2）队长成功邀请20位以上好友加入并交易即可获币王精美周边套装。',
  ssgz2: '2、队员福利：队员每邀请一位好友加入可获500USDT模拟合约金，邀请奖励50000USDT封顶',
  ssgz3: '3、团队赛结束后平台将以战队实际总交易额为判定标准进行最终总排名',
  ssgz4: '4、模拟大赛团队赛区总交易额将于每日0点更新',
  ssgz5: '5、为保证比赛结果的公正性，请勿恶意刷单，如发现恶意刷单伪造交易数据的行为，biking客服团队将介入。模拟大赛团队赛区总交易额将于每日0点更新',
  ssgz6: '6、了解详细活动规则请联系biking客服团队。',
  jlfp: '奖励分配：',
  jlfp1: '1、USDT奖金分配：（奖金发放时，模拟合约专项金与现金始终按照9:1比例进行分配）',
  jlfp1_1: '1）战队内部分配比例：',
  jlfp1_2: '队长可获奖金=队长个人累计合约交易额/Biking模拟大赛团队赛交易总额*5000000USDT',
  jlfp1_3: '+团队内其它队员业绩总和/Biking模拟大赛团队赛交易总额*20%*5000000USDT。',
  jlfp1_4: '战队成员可获得奖金=该用户当前累计合约交易额/Biking模拟大赛团队赛交易总额*80%*5000000USDT。',
  jlfp1_5: '2）比赛期间表现优异的战队可享受集体收益加成！收益加成比例以团队人数和团队总交易额为判定标准，团队人数/总交易额每翻倍一次，即可享受50%算力加成',
  myptdjyze: '模拟大赛团队赛区总交易额',
  myptdphb: '模拟大赛团队排行榜',
  tdsl: '当前团队数量：{v1}，选择自己想要加入的团队',
  tznc: '团长昵称：',
  tdjs: '团队介绍：',
  // 周明星规则
  mypzmxgzsm: '模拟大赛周明星赛比赛规则说明',
  zmxphb: '周明星团队排行榜（只取前三）',
  zmxtdphb: '周明星团队排行榜',
  bdxq: '榜单详情：',
  bdxq1: '1、成功组建战队并开始交易即默认参与周明星战队榜排名',
  zmxgz: '1、系统将以每一个自然周为一周期，按照战队总交易额对当前参赛战队进行排名并公示“周明星战队榜”，榜单前3名战队将共同瓜分2000000USDT合约模拟金奖励',
  zmxgz1: '2、周明星战队榜于每周三14：00更新',
  bddym: '榜单第一名获赠1000000USDT模拟合约金；',
  dbdem: '第二名获赠600000USDT模拟合约金；',
  bddsm: '第三名获赠400000USDT模拟合约金；',
  tdnbfpgz: '团队内部分配规则：',
  tzx: '团长享：20%；',
  nbyjpm: '内部业绩排名前十团员（除团长）：瓜分40%',
  syty: '剩余团员：40%',
  // 个人赛规则
  mypgrsgzsm: '模拟个人赛比赛规则说明',
  mypgrphb: '模拟大赛个人排行榜',
  bsxz: '比赛须知：',
  bsxz1: '1、每位新用户报名参赛即可获得100000USDT模拟合约金',
  bsxz2: '2、老用户报名参赛可获得50000USDT模拟合约金',
  bsxz3: '2、参赛期间用户可通过邀请好友参赛的方式继续获得体验金：',
  bsxz4: '1）用户每邀请一位好友参赛即可获得2000USDT模拟体验金；',
  // bsxz5: '2）每邀请一位老用户参与比赛即可获得2000USDT体验金：',
  bsxz6: '2）邀请奖励最高累计50000USDT模拟合约金封顶',
  bsxz7: '3、该赛区仅对币王交易所实名用户开放。',
  bsxz8: '4、比赛结束后以将以参赛用户的最终总交易额为判定标准进行个人赛区排名。',
  grgzsm1: '1、总奖池：2000000USDT+30份精美周边',
  grgzsm2: '2、分配详情：',
  grgzsm3: '第一名：800000USDT+5份精美周边',
  grgzsm4: '第二名：500000USDT +5份精美周边',
  grgzsm5: '第三名：200000USDT +3份精美周边',
  grgzsm6: '第四-二十名：瓜分500000USDT+17份精美周边',
  hyjybs: '合约交易比赛',
  hyjybsgzsm: '合约交易比赛规则说明',
  hyspgrphb: '合约大赛个人排行榜',
  // 合约大赛规则
  csxz: '参赛须知：',
  hybsgz1: '1、报名参与合约交易大赛即可获得价值100USDT的合约专项金（专项金使用标准参考平台相关细则），该专项金交易盈利不计入账户参赛期间总盈利率。',
  hybsgz2: '2、用户可邀请好友参与合约交易大赛，每成功邀请一位好友参赛，即可获得20USDT合约专项金奖励，邀请奖励上限为100USDT。',
  hybsgz3: '3、本赛区仅对币王交易所实名用户开放。',
  hybsgz4: '4、比赛结束后系统将以比赛期间用户的总收益率为判定标准进行大赛排名。',
  jcfp: '奖池分配：',
  jcfp1: '总奖池：2000000USDT+30份精美周边',
  fpgz: '分配规则：',
  fpgzs: '（奖金发放时，合约专项金与现金始终按照9:1比例进行分配）',
  fpgz1: '第一名：800000USDT+5份精美周边',
  fpgz2: '第二名：500000USDT+5份精美周边',
  fpgz3: '第三名：200000USD+3份精美周边',
  fpgz4: '第四-二十名：瓜分500000USDT+17份精美周边',
  hjyq: '获奖要求',
  hjyq1: '1、合约大赛收益额= 账户最终净值（包含未实现盈亏）- 账户初始净值（包含未实现盈亏）- 参赛合约赠金。',
  hjyq2: '2、若遇到收益额相同的参赛用户，则交易额更高的一方获胜。',
  hjyq3: '3、获奖用户需满足账户收益额大于0。',
  // 捐赠
  gyc1: '该奖池仅对合约交易大赛区及现货赛区的用户开放，用户可提前结束比赛，并将当前交易额/盈利率以捐赠形式打入公益池。',
  gyc2: '系统将按每一个收益百分点*0.5USDT的比例向公益池打入公益奖金，奖池余额将在比赛页面进行公示',
  gyc3: '如用户A实际盈利率38%，则该用户进行捐赠时，系统同步向公益池内打入38*0.5=19USDT（公益奖金为合约专项金）。',
  gyc4: '公益池累计金额上限：50000USDT合约专项金',
  gyc5: '用户捐赠交易额时，系统将按每100USDT交易额=0.5USDT公益金得比例向公益池内进行捐赠，例：如B用户总交易额为1000USDT，捐赠到公益池为0.5USDT*10=5USDT（公益奖金为合约专项金）',
  gyc7: '捐赠须知：每位用户仅可参与一次公益捐赠，一旦捐赠成功，即视为用户放弃整个biking交易大赛的排名资格、获奖资格，及参赛资格（合约交易赛区用户进行公益捐赠后不可再参与后续现货交易大赛）。',
  gyc8: '比赛结束后，公益奖池将开启三轮抽奖，每轮将抽取10人均分奖金，三轮奖金分配比例为：40%、30%、30%。',
  gyc9: '开奖时间：交易大赛结束后7个工作日内随机开奖。详情可咨询官方工作人员。',
  xhjybs: '现货交易比赛',
  xhjybsgzsm: '现货交易比赛规则说明',
  xhjydsphb: '现货交易大赛排行榜',
  grbmcg: '个人报名成功！',
  // 现货实大赛规则
  xhgz1: '1、現貨交易賽包含平台所有現貨交易對',
  xhgz2: '2、参赛用户需满足平台现货账户余额大于50USDT',
  xhgz3: '3、比赛结束后，平台将以用户现货总交易额为判定标准进行赛区总排名',
  jjfp: '奖金分配',
  zjc: '总奖池：1000000USDT+20份精美周边',
  xhdym: '第一名：400000USDT+10份周边',
  xhdem: '第二名:200000USDT+5份周边',
  xhdsm: '第三名：100000USDT+5份周边',
  xhdsm1: '第四-二十名：瓜分300000USDT',
  mypdnpm: '模拟大赛队内排行榜',
  yqjl1: '邀请奖励',
  wdjye: '我的交易额：',
  wdzsyl: '我的总收益率：',
  grzjyl: '模拟大赛个人总交易量：',
  grzsyl: '模拟大赛个人总收益率：',
  sqzjye: '模拟大赛赛区总交易额：',
  zjye: '赛区总交易额：',
  bsyqrs: '比赛邀请人数：',
  ren: '人',
  hdmnj: '获得模拟金：',
  hdzj: '获得赠金：',
  hyjyxq: '合约交易赛详情',
  xhjyxq: '现货交易赛详情',
  hy: '合约',
  xh: '现货',
  jlsm: '奖励说明',
  jlsm1: '1.比赛期间用户（需实名认证后）可随意开团，合约团队赛需满足团队人数 ≥ 5人；≤200人；开团后24H内未满5人，则战队将被自动解散。',
  jlsm2: '2.每人只能加入一个战队，不可重复，且无法主动退出战队',
  tdjye: '团队交易额：',
  wdjs: '我的角色：',
  dz: '队长',
  dy: '队员',
  tdzyll: '团队总盈利率：',
  wdzyll: '我的总盈利率：',
  tdyjhdjl: '团队预计获得奖励：',
  tdjs1: '团队介绍',
  grxq: '个人详情',
  tdxq: '团队详情',
  tdjylpm: '团队交易量排名：',
  tdzsyl: '团队总收益率',
  tdnphb: '团队内排行榜',
  tcsybs: 'Tips: 捐赠完成即退出所有比赛',
  zwcjhybs: '暂未参加模拟合约比赛',
  zwsj: '暂无数据',
  tdmcbzq: '团队名称格式不正确',
  tdjjbzq: '团队简介格式不正确',
  hdjxz_contract: '永续合约交易大赛激烈进行时，参与比赛瓜分2000000U奖金池赢取丰厚币王周边',
  hdjxz_spot: '现货交易大赛激烈进行时，参与比赛瓜分1000000U奖金池赢取丰厚币王周边',
  hdjs: '敬請期待下輪賽開啟',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/tw.js